import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./olo_custom_field_key.js";
//#region src/olo_custom_field_key_helper.ts
var olo_custom_field_key_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(oloOrderField) {
	switch (oloOrderField) {
		case "guestPhoneNumber": return "Guest Phone Number";
		case "guestEmail": return "Guest Email";
		case "tableNumber": return "Guest Table Number";
		case "isI9nFutureOrder": return "Future Order Time";
		case "guestVehicle.make": return "Guest Vehicle Make";
		case "guestVehicle.model": return "Guest Vehicle Model";
		case "guestVehicle.color": return "Guest Vehicle Color";
		case "loyaltyAuthData.customerId": return "Loyalty Customer ID";
		case "emptyValue": return "Empty Value";
		case "templateString": return "Template String";
	}
}
//#endregion
export { name, olo_custom_field_key_helper_exports };

//# sourceMappingURL=olo_custom_field_key_helper.js.map